module.exports = __webpack_public_path__ + "img/btn-join-now-en.6c592856.png";